import { DocumentTextIcon, VideoCameraIcon, UserGroupIcon } from '@heroicons/react/24/outline';
import { H2, H3, Body } from '../ui/Typography';

export default function AdditionalResources() {
  const resources = [
    {
      title: "Whitepaper",
      description: "Detailed technical documentation about RentFi",
      icon: DocumentTextIcon,
      link: "https://rebrand.ly/hjm26ra"
    },
    {
      title: "Tutorial Videos",
      description: "Step-by-step guides on using RentFi",
      icon: VideoCameraIcon,
      link: "https://www.youtube.com/@RentFi"
    },
    {
      title: "Community Forum",
      description: "Join discussions with other Rentizens",
      icon: UserGroupIcon,
      link: "https://t.me/rentfi_io"
    }
  ];

  return (
    <div className="bg-white rounded-xl shadow-lg p-8">
      <H2 className="text-primary mb-6">
        Additional Resources
      </H2>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {resources.map((resource, index) => (
          <a
            key={index}
            href={resource.link || "#"}
            target="_blank"
            rel="noopener noreferrer"
            className="bg-gray-50 rounded-lg p-6 hover:bg-gray-100 transition-colors"
            aria-label={`Access ${resource.title.toLowerCase()} - ${resource.description}`}
          >
            <resource.icon className="w-8 h-8 text-secondary mb-4" />
            <H3 className="text-gray-900 mb-2">{resource.title}</H3>
            <Body className="text-gray-600">{resource.description}</Body>
          </a>
        ))}
      </div>
    </div>
  );
}